import Box from '@mui/material/Box';
import React, { createContext, CSSProperties, ReactNode, useContext, useState } from 'react';

import SiteHeader from '../SiteHeader';

interface Props {
  children: ReactNode;
}

const headerHeight = 64;

const LayoutType = {
  default: {
    marginTop: `${headerHeight}px`,
    paddingTop: 5,
    paddingLeft: 3,
    paddingRight: 3,
    paddingBottom: 5,
    width: '100%',
    marginRight: 'auto',
    marginLeft: 'auto',
    minWidth: 320,
    maxWidth: 1440,
    minHeight: `calc(100vh - ${headerHeight}px)`,
  },
  fullScreen: {
    marginTop: `${headerHeight}px`,
    paddingTop: 0,
    paddingLeft: 0,
    paddingRight: 0,
    paddingBottom: 0,
    width: '100%',
    marginRight: 'auto',
    marginLeft: 'auto',
    minHeight: `calc(100vh - ${headerHeight}px)`,
  },
} as const;

type LayoutType = keyof typeof LayoutType;

type SetLayoutPropsFn = (layout: LayoutType) => void;

const LayoutContext = createContext<SetLayoutPropsFn | undefined>(undefined);

export const useSiteLayout = (): SetLayoutPropsFn => {
  return useContext(LayoutContext) as SetLayoutPropsFn;
};

const SiteLayout = ({ children }: Props) => {
  const [styles, setStyle] = useState<CSSProperties>(LayoutType.default);

  const setLayout = (layout: LayoutType) => {
    setStyle(LayoutType[layout]);
  };

  return (
    <LayoutContext.Provider value={setLayout}>
      <div style={{ display: 'flex' }}>
        <SiteHeader />
        <Box sx={styles}>{children}</Box>
      </div>
    </LayoutContext.Provider>
  );
};

export default SiteLayout;
